import React, { useState } from 'react';
import { createAdminUser } from '../utils/createAdminUser';
import { useNavigate } from 'react-router-dom';

const CreateAdmin: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleCreateAdmin = async () => {
    setLoading(true);
    setMessage('');
    
    try {
      await createAdminUser();
      setMessage('Admin user created successfully! You can now login with admin@avis.com / admin123');
    } catch (error: any) {
      setMessage(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Create Admin User
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            This will create an admin user for the system
          </p>
        </div>
        
        <div className="mt-8 space-y-6">
          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Admin Credentials</h3>
            <div className="space-y-2">
              <p><strong>Email:</strong> admin@avis.com</p>
              <p><strong>Password:</strong> admin123</p>
            </div>
          </div>

          <div className="space-y-4">
            <button
              onClick={handleCreateAdmin}
              disabled={loading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-avis-blue hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-avis-blue disabled:opacity-50"
            >
              {loading ? 'Creating...' : 'Create Admin User'}
            </button>

            <button
              onClick={() => navigate('/admin/login')}
              className="w-full flex justify-center py-2 px-4 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-avis-blue"
            >
              Go to Login
            </button>
          </div>

          {message && (
            <div className={`p-4 rounded-md ${
              message.includes('Error') 
                ? 'bg-red-50 text-red-700 border border-red-200' 
                : 'bg-green-50 text-green-700 border border-green-200'
            }`}>
              {message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateAdmin;
